import * as React from 'react';
import { Provider } from 'react-redux';
import { registerReducersToRoot } from 'ui/reducers/store';
import { ThemeProvider } from 'ui/styled';
import theme from 'ui/theme';
import datashopTheme from '@datashop/theme';
import SidebarApp from 'ui/apps';
import { BrowserRouter as Router, Route } from 'react-router-dom';

const appConfig = (window as any).datashop.app.config();
const appBase = appConfig.siteprefix !== '/' ? appConfig.siteprefix : '';

interface IProps {
  basePath?: string;
  getStore: RegisterReducer;
  visibleApps: string;
  combineWithPatientStore: string;
}

class App extends React.Component<IProps> {
  public render() {
    const { getStore, visibleApps, combineWithPatientStore } = this.props;
    return (
      <Router basename={appBase}>
        <Route path={'/patient/:empi'}>
          <Provider store={registerReducersToRoot(getStore, combineWithPatientStore)}>
            <ThemeProvider theme={{ ...theme, ...datashopTheme }}>
              <SidebarApp visibleApps={visibleApps} />
            </ThemeProvider>
          </Provider>
        </Route>
      </Router>
    );
  }
}

export default App;
